import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationsEN from "./en.json";
import translationsES from "./es.json";
// The translations
const resources = {
  en: {
    translation: translationsEN
  },
  es: {
    translation: translationsES
  }
};

export const changeLanguage = (lng) => {
  i18n.changeLanguage(lng);
};

i18n.use(initReactI18next).init({
  resources,
  lng: "es", // if you're using a language detector, do not define the lng option
  fallbackLng: "es",
  interpolation: {
    escapeValue: false // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
  }
});
